const apiUrl = process.env.REACT_APP_API_URL;

/** Emails d'una activitat concreta */
export const GetEmailsPerActivitat = async (page: string, idacti: string): Promise<any[]> => {
    try {
        const response = await fetch(`${apiUrl}:8073/emails/activitat/${idacti}`, {
            method: 'GET',
            headers: {'Content-Type': 'application/json', 'pantalla': 'loop'}
        });
        if (!response.ok) return [];
        const jsonData = await response.json();
        return Array.isArray(jsonData) ? jsonData : [];
    } catch (error) {
        console.log('GetEmailsPerActivitat error:', error);
        return [];
    }
};

/** Emails de tots els alumnes actius d'una escola */
export const GetEmailsPerEscola = async (page: string, idcent: string): Promise<any[]> => {
    try {
        const response = await fetch(`${apiUrl}:8073/emails/escola/${idcent}`, {
            method: 'GET',
            headers: {'Content-Type': 'application/json', 'pantalla': 'loop'}
        });
        if (!response.ok) return [];
        const jsonData = await response.json();
        return Array.isArray(jsonData) ? jsonData : [];
    } catch (error) {
        console.log('GetEmailsPerEscola error:', error);
        return [];
    }
};

/** Emails de múltiples activitats (idacti separats per coma) */
export const GetEmailsMultiples = async (page: string, ids: string): Promise<any[]> => {
    try {
        const response = await fetch(`${apiUrl}:8073/emails/activitats/multiples?ids=${encodeURIComponent(ids)}`, {
            method: 'GET',
            headers: {'Content-Type': 'application/json', 'pantalla': 'loop'}
        });
        if (!response.ok) return [];
        const jsonData = await response.json();
        return Array.isArray(jsonData) ? jsonData : [];
    } catch (error) {
        console.log('GetEmailsMultiples error:', error);
        return [];
    }
};
